import { memo } from 'react';

import MicrosoftIcon from '@/assets/microsoft-logo.svg?react';
import { Logo, LogoProps } from '@/components/core';

export type MicrosoftLogoProps = LogoProps;

const IMicrosoftLogo = ({ className, ...rest }: MicrosoftLogoProps) => {
  return (
    <Logo className={className} {...rest}>
      <MicrosoftIcon />
    </Logo>
  );
};

export const MicrosoftLogo = memo(IMicrosoftLogo) as typeof IMicrosoftLogo;
